import { render, staticRenderFns } from "./CreateAttraction.vue?vue&type=template&id=82b5756c"
import script from "./CreateAttraction.vue?vue&type=script&lang=js"
export * from "./CreateAttraction.vue?vue&type=script&lang=js"
import style0 from "./CreateAttraction.vue?vue&type=style&index=0&id=82b5756c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports